import { cn } from "@/lib/utils";
import { getScoreTier } from "@/lib/theme";

interface ScoreBadgeProps {
  score: number;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function ScoreBadge({ score, size = "md", className }: ScoreBadgeProps) {
  const tier = getScoreTier(score);
  const color = tier?.color ?? "#5A6A68";
  const pulse = tier?.pulse ?? false;

  const dims = {
    sm: { width: 32, fontSize: 14 },
    md: { width: 40, fontSize: 18 },
    lg: { width: 56, fontSize: 28 },
  }[size];

  return (
    <div
      className={cn(
        "flex items-center justify-center rounded-full font-mono font-bold shrink-0",
        pulse && "animate-pulse-glow",
        className
      )}
      style={{
        width: dims.width,
        height: dims.width,
        fontSize: dims.fontSize,
        color,
        backgroundColor: `${color}15`,
        border: `2px solid ${color}`,
        boxShadow: `0 0 16px ${color}40`,
      }}
    >
      {score}
    </div>
  );
}
